import { styled } from "@mui/material";
import { ABS_POSITION_STYLES, ABS_POSITIONS, DEFAULT_ABS_POSITION } from "../../../utils/constants/viewConstants";
import { FLOATING_CONTAINER_ZINDEX as zIndex } from "../../../utils/constants/otherConstants";

const FloatingContainerPhantom = styled('div')(() => ({
    display: 'block',
    width: "100%",
    boxSizing: "border-box"
}))

const FloatingContainer = ({children, position = DEFAULT_ABS_POSITION, phantomSize = 0}) => {
    const pointerEventsClass = phantomSize === 0 ? 'no-pointer-events' : '';

    const phantomStyle = () => {
        if(position === ABS_POSITIONS.bottom || position === ABS_POSITIONS.top)
        {
            return { height: phantomSize };
        }

        if(position === ABS_POSITIONS.left || position === ABS_POSITIONS.right)
        {
            return { width: phantomSize };
        }

        return { height: phantomSize, width: phantomSize };
    }

    const containerStyle = () => {
        const base = ABS_POSITION_STYLES[position];
        const zIndexStyle = { zIndex }

        return {...base, ...phantomStyle(), ...zIndexStyle};
    }

    return (
        <>
            {
                phantomSize !== 0 && <FloatingContainerPhantom sx={phantomStyle()} />
            }
            <div className={`fixed-position ${pointerEventsClass}`} style={containerStyle()}>
                {children}
            </div>
        </>
    );
}

export default FloatingContainer;